export default __webpack_public_path__ + "static/media/backgroundEmUmContratoWeb.e1d1245a.png";